import axios, { AxiosRequestConfig } from "axios"
import CONFIG from "./config"
import qs from 'qs'
import { AnwendungslisteAPIApi, BetriebsmeldungenAPIApi, BMBCommentsAPIApi, BMBLikeAPIApi, BMBTimestampAPIApi, IntranetAPIApi } from "@/generated/openapi"

const baseOptions: AxiosRequestConfig = {
  baseURL: CONFIG.baseApiUrl,
  paramsSerializer: params => {
    console.debug('serializing', params)
    return qs.stringify(params, { indices: false, skipNulls: true })
  }
}

const httpClient = axios.create(baseOptions)

const anwendungslisteApi = new AnwendungslisteAPIApi(undefined, '', httpClient)
const betriebsmeldungenApi = new BetriebsmeldungenAPIApi(undefined, '', httpClient)
const commentsApi = new BMBCommentsAPIApi(undefined, '', httpClient)
const likeApi = new BMBLikeAPIApi(undefined, '', httpClient)
const timestampApi = new BMBTimestampAPIApi(undefined, '', httpClient)
const meApi = new IntranetAPIApi(undefined, '', httpClient)

export {
  baseOptions,
  httpClient,
  anwendungslisteApi,
  betriebsmeldungenApi,
  commentsApi,
  likeApi,
  timestampApi,
  meApi
};
